import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { SessionService } from "../../../services/session.service";
import { UserService } from '../../../services/user.service';

import { Role } from '../../../interfaces/user';

@Component({
  selector: 'menu-items-right',
  templateUrl: './menu-items-right.component.html',
  standalone: false
})
export class MenuItemsRightComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  public session = inject(SessionService);
  private userService = inject(UserService);
  isSkyMarshal = this.authService.getUser()?.role === Role.Marshal;
  isAdmin = this.authService.getUser()?.role === Role.Master;

  logout () {
    this.session.resetAllData();
    this.authService.setUser(undefined);
    this.authService.clearAuth();
    this.router.navigate(['/login']);
  };

  editUser () {
    this.userService.editUser(this.authService.getUser());
  };
}
